import { Vertical } from "@assets/styled/flex";
import styled from "@emotion/styled";

export const StyledUseCase = styled(Vertical)`
  width: 100%;
  padding: 128px 0;
  background-color: ${({ theme }) => theme.BACKGROUND_SECONDARY};

`;
